export default {
  title: "募集案件　お気に入り一覧",
};
